import { formatAddress } from "@/lib/utils";
import { usePostHog } from "@posthog/react";
import {
  useConnectWallet,
  usePrivy,
  type BaseConnectedWalletType,
} from "@privy-io/react-auth";
import { useWallets } from "@privy-io/react-auth/solana";
import { useEffect, useMemo, useCallback, useRef } from "react";
import { toast } from "sonner";

const ignoredWalletClient = ["privy", "Mobile Wallet Adapter"];

export const AuthCheckForWMA = () => {
  const posthog = usePostHog();
  const { ready: privyReady, authenticated, user, logout } = usePrivy();
  const { ready: solanaWalletReady, wallets } = useWallets();
  const hasAttemptedConnect = useRef(false);

  const handleConnectSuccess = useCallback(
    async ({ wallet }: { wallet: BaseConnectedWalletType }) => {
      console.log("wallet", wallet);
      hasAttemptedConnect.current = false;
    },
    [],
  );

  const handleConnectError = useCallback(
    async (error: unknown) => {
      console.log(error);
      posthog.reset(true);
      hasAttemptedConnect.current = false;
      await logout();
    },
    [posthog, logout],
  );

  const { connectWallet } = useConnectWallet({
    onSuccess: handleConnectSuccess,
    onError: handleConnectError,
  });

  const isUserInWallet = useMemo(() => {
    if (!user) return false;
    if (!user.wallet) return false;
    if (!wallets.length) return false;
    return wallets.some((wallet) => wallet.address === user.wallet?.address);
  }, [wallets, user]);

  useEffect(() => {
    if (privyReady && !authenticated) return;
    if (!user || !user.wallet) return;
    if (ignoredWalletClient.includes(user.wallet.walletClientType ?? ""))
      return;

    if (hasAttemptedConnect.current) return;

    // NOTE: TO CHECK THE EFFECTS DATA FLOW
    console.log("[CFL] App WMA", {
      privyReady,
      authenticated,
      solanaWalletReady,
      isUserInWallet,
      wallets,
      address: user?.wallet?.address,
      user: user,
    });
    // if (solanaWalletReady && !wallets.length && !user.wallet.) {
    //   hasAttemptedConnect.current = false;
    //   toast.error(
    //     "Your wallet connection is lost. Please re-connect to proceed",
    //   );
    //   (async () => {
    //     posthog.reset(true);
    //     await logout();
    //   })();
    // }
  }, [
    connectWallet,
    logout,
    privyReady,
    authenticated,
    solanaWalletReady,
    isUserInWallet,
    user,
    wallets,
    posthog,
  ]);

  return <></>;
};
